export enum LeadSource {
  FACILITY_PARTNERS = "Facility Partners",
  PHYSICIAN_REFERRAL = "Physician Referral",
  COMMUNITY_OUTREACH_EVENT = "Community Outreach Event",
  PL_DIRECT = "PL Direct",
}
